import { render, staticRenderFns } from "./ContainerTab.vue?vue&type=template&id=a356ad66&scoped=true&"
import script from "./ContainerTab.vue?vue&type=script&lang=ts&"
export * from "./ContainerTab.vue?vue&type=script&lang=ts&"
import style0 from "./ContainerTab.vue?vue&type=style&index=0&id=a356ad66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a356ad66",
  null
  
)

export default component.exports